import React from "react"
import PropTypes from "prop-types"
import { Modal, Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { CloseOutlined } from "@ant-design/icons"
import warningIcon from "assets/icons/warningIcon.svg"
import styles from "./UnsavedChangesModal.module.css"

const UnsavedChangesModal = ({ open, onDiscard, onKeepEditing, onSave, title, description, discardLabel, saveLabel, zIndex = 1100 }) => {
  const { t } = useTranslation()
  const isSaveVariant = Boolean(onSave)

  const resolvedTitle = title ?? (isSaveVariant ? t("experiences.wizard.save_changes_modal.title") : t("common.unsaved_changes_modal.title"))
  const resolvedDescription = description ?? (isSaveVariant ? t("experiences.wizard.save_changes_modal.description") : t("common.unsaved_changes_modal.description"))
  const resolvedDiscardLabel = discardLabel ?? (isSaveVariant ? t("experiences.wizard.save_changes_modal.leave") : t("common.unsaved_changes_modal.keep_editing"))
  const resolvedSaveLabel = saveLabel ?? (isSaveVariant ? t("experiences.wizard.save_changes_modal.save") : t("common.unsaved_changes_modal.discard"))

  return (
    <Modal
      open={open}
      onCancel={onKeepEditing}
      closable={false}
      zIndex={zIndex}
      centered
      maskClosable={false}
      footer={null}
      width={400}
      className={styles.modal}
    >
      <Button type="text" onClick={onKeepEditing} className={styles.closeButton}>
        <CloseOutlined />
      </Button>

      <Flex justify="center" className="mb-m">
        <Flex justify="center" align="center" className={styles.warningIcon}>
          <img src={warningIcon} alt="warning" width="24" height="24" />
        </Flex>
      </Flex>

      <h2 className={styles.title}>{resolvedTitle}</h2>
      <p className={styles.description}>{resolvedDescription}</p>

      <Flex gap={8} className={styles.footer}>
        {isSaveVariant ? (
          <>
            <Button color="danger" variant="outlined" onClick={onDiscard} className={styles.actionBtn}>
              {resolvedDiscardLabel}
            </Button>
            <Button type="primary" onClick={onSave} className={styles.actionBtn}>
              {resolvedSaveLabel}
            </Button>
          </>
        ) : (
          <>
            <Button color="primary" variant="outlined" onClick={onKeepEditing} className={styles.actionBtn}>
              {resolvedDiscardLabel}
            </Button>
            <Button type="primary" danger onClick={onDiscard} className={styles.actionBtn}>
              {resolvedSaveLabel}
            </Button>
          </>
        )}
      </Flex>
    </Modal>
  )
}

UnsavedChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  discardLabel: PropTypes.string,
  saveLabel: PropTypes.string,
  zIndex: PropTypes.number
}

export { UnsavedChangesModal }
